import { Spinner } from 'reactstrap';
import PropTypes from 'prop-types';

const PageLoader = ({ isLoading, children }) => {
  return (
    <div style={{ position: 'relative' }}>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.7)',
            zIndex: 1050,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '0.5rem',
          }}
        >
          <Spinner
            color="primary"
            style={{ width: '3rem', height: '3rem' }}
            type="border"
            children={false}
            className="visually-hidden"
          />
        </div>
      )}
      {children}
    </div>
  );
};

PageLoader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default PageLoader;
